// extracted by mini-css-extract-plugin
export default {"paragraph":"paragraph_paragraph__oyXuI","error":"paragraph_error__Jv3s5","gradient":"paragraph_gradient__9KwkB"};